"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonUtilsError = void 0;
/**
 * A simple, named error-with-data to avoid having to import @indigo-ag/error package.
 * (At time of writing, importing @indigo-ag/error into the common package would cause
 * a circular dependency issue between those packages.)
 */
class CommonUtilsError extends Error {
    constructor(message, data) {
        super(message);
        Object.defineProperty(this, 'name', { value: this.constructor.name });
        this.data = data;
    }
}
exports.CommonUtilsError = CommonUtilsError;
//# sourceMappingURL=error.js.map